import { render, staticRenderFns } from "./TasklistTemplateList.vue?vue&type=template&id=a602a8a0"
import script from "./TasklistTemplateList.vue?vue&type=script&lang=js"
export * from "./TasklistTemplateList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports